import React, { useEffect, useState } from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import ErrorMessage from './components/ErrorMessage';
import { teamManagementUrl } from '../../common/config';
import { TeamLifecycleEvent } from '../../models/TeamLifecycleEvent';
import { performLifecycleTransition } from '../../api/TeamApi';

const PersonalizationCompletionSuccessPage: React.FC = () => {
  const lifecycleEvent = { command: 'teamCompletePersonalization' } as TeamLifecycleEvent;
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    performLifecyclePersonalizationCompletion();
  }, []);

  const performLifecyclePersonalizationCompletion = async () => {
    try {
      const response = await performLifecycleTransition(lifecycleEvent);
      if (response && response.phase === 'personalization_completed') {
        window.location.assign(teamManagementUrl() + '?personalisierungAbgeschlossen=true');
      } else {
        setError(new Error());
      }
    } catch (e) {
      setError(e);
    }
  };

  return (
    <PageWrapper title='Hauptkontoänderung-Erfolgreich'>
      <div className='margin-vertical-xl align-center'>{error && <ErrorMessage />}</div>
    </PageWrapper>
  );
};
export default PersonalizationCompletionSuccessPage;
